// This file is copied from https://github.com/googleapis/api-common-protos/blob/main/google/type/latlng.proto
// and modified to use the carmen package.

// Copyright 2020 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/latlng.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/latlng.proto.
 */
export const file_proto_model_core_latlng = /*@__PURE__*/
  fileDesc("Ch1wcm90by9tb2RlbC9jb3JlL2xhdGxuZy5wcm90bxIGY2FybWVuIi0KBkxhdExuZxIQCghsYXRpdHVkZRgBIAEoARIRCglsb25naXR1ZGUYAiABKAFCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw");

/**
 * Describes the message carmen.LatLng.
 * Use `create(LatLngSchema)` to create a new message.
 */
export const LatLngSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_latlng, 0);

